import React, { useState } from 'react';
import { AVATARS, identityFor } from '../playerIdentity';

export default function PlayerAvatar({ player = {}, className = '' }) {
  const identity = identityFor(player);
  const avatar = AVATARS.find(a => a.id === identity.avatarId);
  const [failed, setFailed] = useState('');
  const photo = identity.photoDataUrl && failed !== identity.photoDataUrl;
  return <span className={`player-avatar ${className}`} role="img" aria-label={photo ? `${player.name || 'Your'} photo` : `${avatar.name} avatar`}>
    {photo ? <img src={identity.photoDataUrl} alt="" onError={() => setFailed(identity.photoDataUrl)} /> : <span className="player-avatar-art" style={{ backgroundPosition: `${avatar.x}% ${avatar.y}%` }} />}
  </span>;
}
